<div class="page-header">
    <div class="row">
        <h3>ثبت نام در سامانه سجام و دریافت کد بورسی</h3>
    </div>
</div>
<article>
    <section class="page-section-1">
        <div class="row">
            <div class="medium-12 column">
                <p>&nbsp;</p>
                <div class="row ">
                    <div class="columns medium-5 medium-pull-7 columns">
                        <p></p>
                        <p style="border: 1px solid #ababab; margin-top: -20px;"><img class="alignnone wp-image-2913"
                                src="../../assets/images/2018-08-18-17.26.33.jpg" alt="" width="800" height="500"><a
                                class="vp-a" href="https://aban.capital/wp-content/grand-media/video/__sh1.mp4"><br>
                                <button class="wpfs button warning radius small ">آموزش ثبت نام در سامانه
                                    سجام</button></a></p>
                        <p></p>
                    </div>
                    <div class="columns medium-7 medium-push-5 columns">
                        <p></p>
                        <h6 style="text-align: justify; font-size: 12pt;"></h6>
                        <p style="text-align: justify;"><span style="color: #000000; font-size: 12pt;">بر اساس اطلاعیه
                                شرکت سپرده گذاری مرکزی اوراق بهادار و تسویه وجوه، کلیه ی سرمایه گذاران فعال در بازار
                                سرمایه کشور، مکلفند ضمن مراجعه به سامانه سجام و تکمیل پرسشنامه، نسبت به ثبت نام در این
                                سامانه اقدام نمایند. لازم به ذکر است پس از گذشت مهلت، کد معاملاتی اشخاصی که در سامانه
                                فوق الذکر، ثبت نام ننموده اند، غیرفعال خواهد گردید. لذا این کارگزاری جهت رفاه حال
                                مشتریان و تسریع و تسهیل در انجام امور، لینک سامانه سجام را در کلیه ی درگاه های اینترنتی
                                خود، نصب و فعال نموده است.<br>
                            </span></p>
                        <p>جهت ثبت نام بر روی لینک زیر کلیک نمایید.</p>
                        <p><span> <a target="_blank" href="https://sejam.aban.net"
                                    class="wpfs button alert2 shezowhitehovercolor radius tiny ">ثبت نام
                                    در سامانه سجام</a><br>
                            </span></p>
                        <p></p>
                    </div>
                </div>
                <h6 style="text-align: justify; font-size: 12pt;"></h6>
                <p>&nbsp;</p>
            </div>
        </div>
    </section>
</article>